import React, { useState, useEffect } from 'react';
import { aboutUsPageData } from '../data/pageData';
import PageTitle from '../components/PageTitle';

const AboutUsPage = () => {
    const data = aboutUsPageData;
    return (
        <div className="bg-white text-gray-800">
            <PageTitle title={data.pageTitle} breadcrumbs={data.breadcrumbs} />
            <section className="py-16 md:py-24">
                <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
                        <div className="lg:w-2/5 animate-slideInLeft">
                            <img src={data.imageSrc} alt="About Jiotronik" className="rounded-xl shadow-2xl w-full object-cover transform hover:scale-105 transition-transform duration-500" />
                        </div>
                        <div className="lg:w-3/5 animate-slideInRight">
                            <h3 className="text-yellow-500 text-sm uppercase tracking-wider font-semibold">{data.sectionTitle}</h3>
                            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold my-4 leading-tight text-gray-900">{data.headline}</h2>
                            <p className="text-gray-700 mb-5 leading-relaxed">{data.description1}</p>
                            <p className="text-gray-700 mb-8 leading-relaxed">{data.description2}</p>
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-10">
                                {data.keyPoints.map(point => (
                                <div key={point.title} className="bg-gray-100 p-6 rounded-xl text-center shadow-xl transform hover:scale-105 transition-transform duration-300">
                                    <span className="text-yellow-500 text-4xl block mb-3">{point.icon}</span>
                                    <h4 className="text-xl font-semibold text-gray-800">{point.title}</h4>
                                    <p className="text-gray-600 text-sm mt-2 leading-relaxed">{point.description}</p>
                                </div>
                                ))}
                            </div>
                            <div>
                                <h4 className="text-2xl font-semibold mb-4 text-gray-900">{data.coreAreasTitle}</h4>
                                <ul className="space-y-2 text-gray-700">
                                    {data.coreAreas.map(area => (
                                    <li key={area} className="flex items-center"><span className="text-yellow-500 mr-3 text-lg">❯</span> {area}</li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default AboutUsPage;